module.exports = __webpack_public_path__ + "img/iconFB.eaf1e3a1.svg";